export default "__VITE_ASSET__cf006aad__"